import React from "react";

const Logout = (props) => (
  <h1 style={{ textAlign: "center" }} className="loading-text">
    {props.loadingText}
  </h1>
);

export default Logout;
